import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DocumentMeta from "react-document-meta";

import Layout from "../Layout";
import { H2RHeading } from "../imports";
import { cuesApi } from "../imports";
import { H2RButton } from "../imports";
import { ReplaceWithDataSource } from "./helpers/variable";
import { faCheck, faMinus, faPlus, faRefresh } from "@fortawesome/free-solid-svg-icons";

export default function Score() {
	let { projectId } = useParams();

	const selectedProject = useSelector(
		(state) => state.main.projects?.[projectId]
	);
	const cues =
		useSelector((state) =>
			state.main?.projects?.[projectId]?.cues?.filter((c) => c.type === "score")
		) || [];

	const meta = {
		title: `Score - ${selectedProject?.name}`,
	};

	const handleUpdateScore = (cueId, team, score, update, clearLevel) => {
		if (clearLevel) {
			cuesApi.updateScore(cueId, projectId, 0, 0, 0);
			cuesApi.updateScore(cueId, projectId, 1, 0, 0);
		}
		return cuesApi.updateScore(cueId, projectId, team, score, update);
	};

	const handleResetScores = (cueId) => {
		cuesApi.updateScore(cueId, projectId, 0, 0, 0);
		cuesApi.updateScore(cueId, projectId, 0, 1, 0);
		cuesApi.updateScore(cueId, projectId, 0, 2, 0);
		cuesApi.updateScore(cueId, projectId, 0, 3, 0);
		cuesApi.updateScore(cueId, projectId, 0, 4, 0);
		cuesApi.updateScore(cueId, projectId, 0, 5, 0);

		cuesApi.updateScore(cueId, projectId, 1, 0, 0);
		cuesApi.updateScore(cueId, projectId, 1, 1, 0);
		cuesApi.updateScore(cueId, projectId, 1, 2, 0);
		cuesApi.updateScore(cueId, projectId, 1, 3, 0);
		cuesApi.updateScore(cueId, projectId, 1, 4, 0);
		cuesApi.updateScore(cueId, projectId, 1, 5, 0);
	};

	if (selectedProject === undefined) {
		return null;
	} else {
		return (
			<DocumentMeta {...meta}>
				<Layout>
					<section className={`mx-5 my-5 flex flex-col flex-1 overflow-auto`}>
						<div className="mt-6 flex flex-col">
							{cues.length === 0 && (
								<span className="text-sm text-gray-600 italic">
									Add a Score graphic to your rundown to get started.
								</span>
							)}
							{cues.map((cue) => {
								if (cue.type !== "score") return null;
								return (
									<div key={cue.id} className="mb-10">
										<div className="flex justify-between items-center mb-4 mr-1">
											<H2RHeading type="h4">
												Score{" "}
												<span className="text-sm text-gray-600">
													({cue.id})
												</span>
											</H2RHeading>
											<H2RButton
												icon={faRefresh}
												text="Reset all"
												colour="dark"
												size="small"
												css="w-min"
												onClick={() => {
													handleResetScores(cue.id);
												}}
											/>
										</div>
										<div className="flex flex-col space-y-3">
											{cue.teams.map((team, ti) => {
												return (
													<div
														key={ti}
														className="px-5 py-4 flex justify-between items-center bg-gray-800 rounded"
													>
														<div className="flex items-center space-x-3">
															{/* <H2RButton
																text="Serve"
																size="small"
																colour="dark"
																disabled={cue.flags.single[0].team === ti}
																onClick={() => {
																	
																}}
															/> */}
															<H2RButton
																text=""
																icon={faCheck}
																size="small"
																colour={
																	cue.activeTeam === ti + 1 ? "dark" : "light"
																}
																onClick={() => {
																	cuesApi.updateCue(cue.id, projectId, {
																		activeTeam: ti + 1,
																	});
																}}
															/>
															<span>
																<ReplaceWithDataSource
																	text={team.name || `Team ${ti + 1}`}
																/>
															</span>
														</div>
														<div className="flex space-x-3">
															{cue.scores.map((score, si) => {
																if (ti !== si) return null;

																return score.map((level, i) => {
																	if (i >= cue.levels) return null;
																	return (
																		<div key={i} className="flex space-x-2">
																			<H2RButton
																				icon={faMinus}
																				colour="dark"
																				css="px-4 py-6"
																				onClick={() => {
																					return handleUpdateScore(
																						cue.id,
																						ti,
																						i,
																						parseInt(level.score - 1)
																					);
																				}}
																			/>
																			{/* <span className="w-14 flex justify-center items-center px-4 bg-gray-900 rounded">
																				{level.score}
																			</span> */}

																			<input
																				type="number"
																				className="w-20 flex justify-center items-center text-center px-2 bg-gray-900 rounded focus:outline-none focus:ring"
																				value={level.score}
																				onChange={(e) =>
																					handleUpdateScore(
																						cue.id,
																						ti,
																						i,
																						parseInt(e.target.value)
																						// i === 1 ? true : false
																					)
																				}
																			/>

																			<H2RButton
																				icon={faPlus}
																				colour="dark"
																				css="px-4 py-6"
																				onClick={() => {
																					return handleUpdateScore(
																						cue.id,
																						ti,
																						i,
																						parseInt(level.score + 1)
																						// i === 1 ? true : false
																					);
																				}}
																			/>
																		</div>
																	);
																});
															})}
														</div>
													</div>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
					</section>
				</Layout>
			</DocumentMeta>
		);
	}
}
